import {Component, inject} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {Button} from "primeng/button";
import {UserService} from "../../../services/user.service";
import {ConfirmationService, MessageService} from "primeng/api";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    Button
  ],
  templateUrl: './account-my-data-page.component.html',
})
export class AccountMyDataPageComponent {
  private readonly userService = inject(UserService);
  private readonly confirmService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);

  private readonly user = this.userService.signedInUser;

  // Subscriptions billed through RevenueCat (App Store / Play Store) cannot be
  // cancelled server-side — Apple in particular only lets the user cancel from
  // their store account. Surface that warning before they request deletion so
  // they don't keep getting charged after their account is gone.
  private activeRevenueCatStore(): 'the App Store' | 'Google Play' | undefined {
    const user = this.user();
    if (!user) return undefined;
    if (user.paymentInfo.type !== 'revenuecat') return undefined;

    const liveStatuses = ['active', 'trialing', 'canceling', 'past-due'];
    if (!liveStatuses.includes(user.simplifiedPaymentInfo.status)) return undefined;

    return user.paymentInfo.os === 'ios' ? 'the App Store' : 'Google Play';
  }

  onDeleteClick() {
    const store = this.activeRevenueCatStore();
    const message = store
      ? `Your Homey subscription is billed through ${store}. Deleting your account does NOT cancel that subscription — you'll keep being charged until you cancel it yourself in ${store}. Are you sure you want to request deletion? We will delete your account in the coming days.`
      : 'Are you sure really sure you want to request your account will be deleted? We will delete it in the coming days.';

    this.confirmService.confirm({
      header: 'Delete account',
      message,
      accept: () => {
        this.userService.requestDeletion().subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Account deletion requested, we will delete your account in the coming days.'
            });
          }
        );
      }
    });
  }
}
